/**
 * Designed by Junhua on 17/2/16.
 */
import axios from './http'
import Qs from 'qs'
import vm from './main'

let urls = {
    login:'/login',    //登陆

    getAllDict:'/dict/getall',
    saveDict:'/dict/save',
    updateDict:'/dict/update',
    deleteDict:'/dict/remove',
    getDictById:'/dict/getone',

    getShopList:'/shop/getlist',
    getShopById:'/shop/getone',
    saveShop:'/shop/save',
    updateShop:'/shop/update',
    deleteShop:'/shop/remove',
    getAllShop:'/shop/getall',

    getGoodsList:'/goods/getlist',
    getGoodsById:'/goods/getone',
    saveGoods:'/goods/save',
    updateGoods:'/goods/update',
    deleteGoods:'/goods/remove',
    getAllGoods:'/goods/getall',

    getHomeList:'/home/getlist',
    getHomeById:'/home/getone',
    saveHome:'/home/save',
    updateHome:'/home/update',
    deleteHome:'/home/remove',
    activateHome:'/home/activate',
    getActiveHome:'/home/getActive',

    getLabelList:'/label/getlist',
    getLabelById:'/label/getone',
    saveLabel:'/label/save',
    updateLabel:'/label/update',
    deleteLabel:'/label/remove',
    getAllLabel:'/label/getall',

    getUserList:'/user/getlist', //获取用户分页列表
    getUserById:'/user/getone', //获取一个用户对象
    saveUser:'/user/save', //新建用户
    updateUser:'/user/update', //更新用户
    deleteUser:'/user/remove',//删除用户
    getAllUser:'/user/getall',
    
    getSale:'/report/sale',
    getStockin:'/report/stockin',
    getMember:'/report/member',

    submitList:'/saleList/submit',
    compressImg:'/demo/compressImg',

    getActList:'activity/getlist',
    saveAct:'activity/save',
    updateAct:'activity/update',
    deleteAct:'activity/remove',
    getAllAct:'activity/getall',
    getActById:'activity/getone',

    saveMenu:'menu/save',
    getMenu:'menu/getone',
    deleteMenu:'menu/remove',

    getOrderList:'orders/getlist',
    refund:'orders/refund',
    complete:'orders/complete',
    getOrderById:'orders/getone',
    getAllOrder:'orders/getall',

    getCustomerList:'customer/getlist',
    updateCustomer:'customer/update',

    getTime:'time',
    totalRep:'report',

    getTxById:'withdrawal/getone',
    getTxList:'withdrawal/getlist',
    txAppr:'withdrawal/appr',

    getDelList:'delivery/getlist',
    saveDel:'delivery/save',
    getDelById:'delivery/getone',
}

//包装get
let getMethod = (url,query) => axios.get(url + '?' + Qs.stringify(query))

let postMethod = (url,query) => axios.post(url , query)//包装post

let post = async function(reqUrl,query,selfHandle){
    console.log(reqUrl)
    if('login'.indexOf(reqUrl) == -1 && localStorage.token){//登录api不需要检查token
        if(query){
            query.token = localStorage.token;
        }else{
            query = {
                token : localStorage.token
            }
        }
    }
    let res = null;
    try{//捕捉请求异常并提示错误
        res = await postMethod(urls[reqUrl],query);
    }catch(e){
        vm.$notify({ message: '远程服务器失联了，请检查您的网络！', type: 'error'});
        return null;
    }
    if(res.data.code == '400' && 'login'.indexOf(reqUrl) == -1){//token失效
        vm.$notify({ message: '身份认证失效,请重新登录！', type: 'error'});
        localStorage.clear();
        sessionStorage.hasBar = 0;
        vm.$router.push({path:'/login'});
        return null;
    }else if(res.data.code != '0'){//其他错误
        if(selfHandle){
            return res;
        }else {
            vm.$notify({ message: res.data.msg, type: 'error'});
            return null;
        }
    }
    else{//正常的情况
        return res;
    }
};

export default {
    post:post,
    url:axios.defaults.baseURL,
}